import { useMemo } from "react";
import { useGetMerchantFilters } from "../../hooks/queries/useMerchantQueries";

export const useMerchantFilterOptions = (enabled = true) => {
  const {
    data: merchants = [],
    isLoading,
    isError,
    error,
  } = useGetMerchantFilters(undefined, { enabled });

  const options = useMemo(
    () =>
      Array.isArray(merchants)
        ? merchants.map((merchant) => ({
            value: merchant.merchantId || "",
            label: merchant.merchantName || "",
          }))
        : [],
    [merchants],
  );

  const optionsWithAll = useMemo(
    () => [{ value: "", label: "All Merchants" }, ...options],
    [options],
  );

  return {
    merchants,
    options,
    optionsWithAll,
    isLoading,
    isError,
    error,
    hasOptions: options.length > 0,
  };
};

export default useMerchantFilterOptions;
